import { Routes } from '@angular/router';
import { TicketListComponent } from './ticket-list/ticket-list.component';
import { ReportsComponent } from './reports/reports.component';
import { OnetimeComponent } from './onetime/onetime.component';
import { SingleTicketComponent } from './single-ticket/single-ticket.component';
import { NotFoundPageComponent } from '@sb-tools/typescript/components/error-pages/not-found-page/not-found-page.component';
import { ForwardTicketComponent } from './forward-ticket/forward-ticket.component';
import { AccessExpiredComponent } from './access-expired/access-expired.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { RedirectToMyTicketsGuard } from './core/redirect-to-my-tickets.guard';
import { RedirectGuard } from './core/redirect.guard';

export const routes: Routes = [
    {
        path: '404',
        component: NotFoundPageComponent,
    },
    {
        path: '403',
        component: AccessExpiredComponent,
    },
    {
        path: ':communityName',
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'tickets',
            },
            {
                path: 'tickets',
                component: TicketListComponent,
                data: { stateName: 'tickets' },
                canActivate: [RedirectToMyTicketsGuard],
            },
            {
                path: 'reports',
                component: ReportsComponent,
                data: { stateName: 'reports' },
            },
            {
                path: 'onetime',
                component: OnetimeComponent,
                data: { stateName: 'onetime' },
            },
            {
                path: 'ticket',
                component: SingleTicketComponent,
                data: { stateName: 'ticket' },
            },
            {
                path: 'forward',
                component: ForwardTicketComponent,
                data: { stateName: 'forward' },
            },
            {
                path: 'notifications',
                component: NotificationsComponent,
                data: { stateName: 'notifications' },
            },
            { path: '**', redirectTo: 'tickets' },
        ],
    },
    { path: '**', canActivate: [RedirectGuard], children: [] },
];
